import React, { useMemo, useState } from "react";
import Modal from "react-modal";
import { useDropzone } from "react-dropzone";
import "cropperjs/dist/cropper.css";
import axios from "axios";
import { showGlobalModal } from "components/GlobalModal";

Modal.setAppElement("#root");

const MultiImageUpload: React.FC<{
  onChange: (file: object) => void;
  imageValue: {
    orignalImage: String;
    selectedImage: String;
    enhancedImage: String;
  };
  label?: string;
  customMessage?: string;
  wantHDOption?: boolean;
  previewNotRequired?: boolean;
  disable?: boolean;
  labelClassNames?: string;
  containerHeight?: string | any; // New prop for flexible height
  maxSize?: number;
}> = ({
  onChange,
  imageValue,
  label,
  customMessage,
  wantHDOption,
  labelClassNames,
  containerHeight, // Default height if not specified
  previewNotRequired,
  disable,
  maxSize = 5,
}) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    // const [orignalImage, setOrignalImage] = useState<string>("");
    // const [enhancedImage, setEnhancedImage] = useState<string>("");
    // const [selectedImage, setSelectedImage] = useState<string>("");
    const [loader, setLoader] = useState<boolean>(false);

    const IS_ORIGNAL_IMAGE = Boolean(
      imageValue?.selectedImage === imageValue?.orignalImage
    );
    const IS_ENHANCED_IMAGE = Boolean(
      imageValue?.selectedImage === imageValue?.enhancedImage
    );

    // useMemo(() => {
    //   if(!!imageValue) {
    //     setSelectedImage(imageValue as any)
    //   }
    // },[imageValue]);

    const handleImageUpload = async (file: File) => {
      if (file.type === "image/jpeg") {
        setLoader((loader) => true);
        const formData = new FormData();
        formData.append("files", file as File);
        const response = await axios.post(
          `https://dev.soomuch.ai/api/v1/master/upload/tempfiles`,
          formData,
          {
            headers: {
              "Custom-Header": "multipart/form-data", // Add custom headers for this specific request
            },
          }
        );
        // setOrignalImage(orignalImage => response?.data?.data?.[0]);
        onChange({
          orignalImage: response?.data?.data?.[0],
          selectedImage: response?.data?.data?.[0],
          enhancedImage: "",
        });
        setLoader((loader) => false);
        setModalIsOpen(true);
      } else {
        showGlobalModal("Only JPG/JPEG files are allowed!", "error");
      }
    };

    const handleSelection = (url) => {
      // setSelectedImage(selectedImage => url);
      onChange({
        ...imageValue,
        selectedImage: url,
      });
    };

    const handleModalCancel = () => {
      // setEnhancedImage(enhancedImage => null);
      setModalIsOpen((modalIsOpen) => false);
    };

    const handleSaveEnhancedImage = () => {
      // onChange(selectedImage);
      // setEnhancedImage(null);
      setModalIsOpen(false);
    };

    const onDrop = (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        if (maxSize && file.size > maxSize * 1024 * 1024) {
          showGlobalModal(`File size exceeds ${maxSize}MB`, "error");
          return;
        }
        handleImageUpload(file);
      }
    };

    const handleEnhanceImage = async () => {
      if (!imageValue?.orignalImage) return;
      try {
        setLoader((loader) => true);
        const response = await axios.post(
          `https://dev.soomuch.ai/api/v1/master/enhance-image`,
          { image_url: imageValue?.orignalImage, preset: "auto_enhance" }
        );
        if (!response?.data?.data?.result_url) {
          showGlobalModal(response?.data?.message, "error");
        } else {
          // setEnhancedImage(enhancedImage => response?.data?.data?.result_url);
          onChange({
            ...imageValue,
            enhancedImage: response?.data?.data?.result_url,
          });
        }
        setLoader((loader) => false);
      } catch (err) {
        setLoader((loader) => false);
        showGlobalModal(err?.data?.message || err?.message, "error");
      }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      accept: { "image/*": [] }, // not gif
      multiple: false,
      disabled: disable,
    });

    return (
      <div className="w-full space-y-2">
        {label && (
          <label
            className={`block text-xs ${labelClassNames}`} /* style={{ color: "white" }} */
          >
            {label} <span className="text-red-600">*</span>
          </label>
        )}

        <div
          {...getRootProps()}
          className={`
          relative 
          flex 
          flex-col 
          items-center 
          justify-center
          px-2 
          py-2
          border 
          border-solid 
          border-slate-900 
          rounded-xl 
          bg-[white]
          overflow-hidden 
          ${isDragActive ? " bg-blue-100" : ""}
        `}
        >
          <input {...getInputProps()} />
          <div className="flex flex-col items-center justify-center gap-1 text-gray-500 w-full">
            <button
              type="button"
              className={`absolute top-2 right-2`}
              onClick={(e) => {
                e.stopPropagation();
                if (!disable) {
                  if (!loader) setModalIsOpen((modalIsOpen) => true);
                }
              }}
              title="Enhance Image"
            >
              {!loader ? (
                !!imageValue?.orignalImage && wantHDOption ? (
                  <img
                    src={"/images/TextGenrator.svg"}
                    className="w-7 h-7"
                    alt="asdgahdgasd"
                  />
                ) : (
                  <></>
                )
              ) : (
                <img
                  src={"/images/loader.gif"}
                  className="w-6 h-6"
                  alt="Loading"
                />
              )}
            </button>
            {!imageValue?.orignalImage || previewNotRequired ? (
              <div className="flex items-center justify-center w-full h-full m-2">
                <div className="relative">
                  <img src="/images/upload-cloud.png" alt="brand frame" className="w-10 h-10" />
                </div>
                {/* <DefaultImage
                width={containerHeight?.width}
                height={containerHeight?.height}
              /> */}
              </div>
            ) : (
              <div
                className={`flex items-center justify-center w-full`}
                style={{ overflow: "hidden" }} // Ensure the image is clipped if it overflows
              >
                <img
                  src={imageValue?.orignalImage as any}
                  alt="Uploaded"
                  className="rounded-md object-contain"
                  style={
                    !!containerHeight
                      ? containerHeight
                      : {
                        width: "48px",
                        height: "48px",
                        objectFit: "contain",
                      }
                  }
                />
              </div>
            )}
            <p className="text-sm truncate w-full text-center"
              style={{ color: "black" }}>
              {isDragActive
                ? "Drop the image here..."
                : "Drag & Drop or Upload Image"}
            </p>
            <p className="text-xs text-gray-500 truncate w-full text-center">
              {/* {customMessage || "PNG, JPG, JPEG (Max 5MB)"} */}
              {customMessage || `JPG, JPEG (Max ${maxSize}MB)`}
            </p>
          </div>
        </div>

        {wantHDOption && (
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleModalCancel}
            contentLabel="Enhance Image"
            className="fixed inset-0 flex items-center justify-center z-50"
            overlayClassName="fixed inset-0 bg-[black] bg-opacity-50 z-40"
          >
            <div className="bg-[white] p-4 rounded-lg w-[60%]">
              <div className="flex flex-row justify-between items-stretch gap-4">
                <div className="w-full">
                  <h3 className="text-base font-bold mb-2">Original Image</h3>
                  {!!imageValue?.orignalImage && (
                    <div className="relative h-64 md:h-80">
                      <img
                        src={imageValue?.orignalImage as any}
                        alt="Original"
                        className={`cursor-pointer rounded-md object-contain w-full h-full ${IS_ORIGNAL_IMAGE
                            ? "border-4 border-indigo-600"
                            : "border border-solid border-slate-900"
                          }`}
                        onClick={() => handleSelection(imageValue?.orignalImage)}
                      />
                    </div>
                  )}
                </div>
                <div className="w-full">
                  <h3 className="text-base font-bold mb-2">Enhanced Image</h3>
                  {!!imageValue?.enhancedImage ? (
                    <div className="relative h-64 md:h-80">
                      <img
                        src={imageValue?.enhancedImage as any}
                        alt="Enhanced"
                        className={`cursor-pointer rounded-md object-contain w-full h-full ${IS_ENHANCED_IMAGE
                            ? "border-4 border-indigo-600"
                            : "border border-solid border-slate-900"
                          }`}
                        onClick={() => handleSelection(imageValue?.enhancedImage)}
                      />
                    </div>
                  ) : (
                    <div className="relative h-64 md:h-80 flex items-center justify-center bg-gray-100 border border-solid border-slate-900 rounded-md">
                      <button
                        type="button"
                        className={`absolute top-2 right-2`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!loader) handleEnhanceImage();
                        }}
                        title="Enhance Image"
                      >
                        {!loader ? (
                          <img
                            src={"/images/TextGenrator.svg"}
                            className="w-6 h-6"
                            alt="app"
                          />
                        ) : (
                          <img
                            src={"/images/loader.gif"}
                            className="w-6 h-6"
                            alt="Loading"
                          />
                        )}
                      </button>
                      <p className="text-sm text-gray-500">
                        No enhanced image available
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex justify-end gap-4 mt-4">
                {/* <button
                  type="button"
                  onClick={handleModalCancel}
                  className="bg-gradient-to-r from-[#844B9F] to-[#A93483] text-[2vh] text-white py-2 px-4 rounded-lg hover:opacity-90 transition-opacity"
                  style={{ color: 'white' }}
                >
                  Cancel
                </button> */}
                <button
                  type="button"
                  onClick={handleSaveEnhancedImage}
                  className="bg-gradient-to-r from-[#844B9F] to-[#A93483] text-[2vh] text-white py-2 px-4 rounded-lg hover:opacity-90 transition-opacity"
                  style={{ color: "white" }}
                >
                  Save Image
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  };

export default MultiImageUpload;

// const DefaultImage = ({ width, height }: { width?: any; height?: any }) => {
//   return (
//     <svg
//       width={width || "48"}
//       height={height || "48"}
//       viewBox="0 0 89 88"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       className="text-gray-300"
//     >
//       <path
//         d="M0.75 71.544C0.75 76.12 2.36333 79.992 5.59 83.16C8.81667 86.328 12.718 87.9413 17.294 88H72.294C76.8113 88 80.6833 86.3867 83.91 83.16C87.1367 79.9333 88.75 76.0613 88.75 71.544V16.544C88.75 11.968 87.1367 8.06667 83.91 4.84C80.6833 1.61333 76.8113 0 72.294 0H17.294C12.718 0 8.81667 1.61333 5.59 4.84C2.36333 8.06667 0.75 11.968 0.75 16.544L0.75 71.544ZM11.75 71.544V16.544C11.75 15.0187 12.278 13.728 13.334 12.672C14.39 11.616 15.71 11.0587 17.294 11H72.294C73.7607 11 75.0513 11.5573 76.166 12.672C77.2807 13.7867 77.8087 15.0773 77.75 16.544V71.544C77.75 73.0693 77.222 74.36 76.166 75.416C75.11 76.472 73.8193 77 72.294 77H17.294C15.7687 77 14.4487 76.472 13.334 75.416C12.2193 74.36 11.6913 73.0693 11.75 71.544ZM17.294 66C17.294 67.5253 17.822 68.8453 18.878 69.96C19.934 71.0747 21.2247 71.6027 22.75 71.544H66.75C68.2753 71.544 69.566 71.016 70.622 69.96C71.678 68.904 72.2353 67.584 72.294 66V63.448C71.8833 62.6267 70.8567 60.1627 69.214 56.056C67.5713 51.9493 66.1047 48.664 64.814 46.2C63.5233 43.736 62.35 41.8 61.294 40.392C60.2967 39.336 59.27 38.7787 58.214 38.72C57.158 38.6613 56.102 39.0133 55.046 39.776C53.99 40.5387 52.934 41.5653 51.878 42.856C50.822 44.1467 49.7367 45.584 48.622 47.168C47.5073 48.752 46.4513 50.3067 45.454 51.832C44.4567 53.3573 43.4007 54.824 42.286 56.232C41.1713 57.64 40.174 58.7253 39.294 59.488C38.414 60.2507 37.4167 60.6613 36.302 60.72C35.246 60.72 33.7207 59.4 31.726 56.76C31.4327 56.408 30.9927 55.8507 30.406 55.088C28.3527 52.3307 26.886 50.6587 26.006 50.072C24.598 49.1333 23.5127 49.456 22.75 51.04C22.3393 51.9787 21.4887 54.032 20.198 57.2C18.9073 60.368 17.9393 62.7147 17.294 64.24V66ZM17.294 24.816C17.294 27.104 18.086 29.04 19.67 30.624C21.254 32.208 23.19 33 25.478 33C27.766 33 29.7313 32.208 31.374 30.624C33.0167 29.04 33.8087 27.104 33.75 24.816C33.6913 22.528 32.8993 20.5627 31.374 18.92C29.8487 17.2773 27.8833 16.4853 25.478 16.544C23.0727 16.6027 21.1367 17.3947 19.67 18.92C18.2033 20.4453 17.4113 22.4107 17.294 24.816Z"
//         fill="#ADABAB"
//       />
//     </svg>
//   );
// };